import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable } from 'rxjs';

@Injectable()
export class AuthService {
  constructor(private keycloakService: KeycloakService) {}

  public getLoggedUser() {
    try {
      const userDetails =
        this.keycloakService.getKeycloakInstance().idTokenParsed;
      return userDetails;
    } catch (e) {
      console.error('Exception', e);
      return undefined;
    }
  }

  public isLoggedIn() {
    return this.keycloakService.isLoggedIn();
  }

  public loadUserProfile() {
    return this.keycloakService.loadUserProfile();
  }

  public login(): void {
    this.keycloakService.login().then((resp) => {
      console.log(resp);
    });
  }

  public logout(): void {
    sessionStorage.removeItem('currentUser');
    //console.log('[Logout]',window.location.origin)
    this.keycloakService.logout(window.location.origin);
  }

  public redirectToProfile(): void {
    this.keycloakService.getKeycloakInstance().accountManagement();
  }

  public getRoles(): string[] {
    return this.keycloakService.getUserRoles();
  }
}
